module.exports = function(app) {
	app.directive('eprTobaccoStatuses', function() {
		return {
			restrict: 'A',
			replace: false,
			template: require('directives/employee/eprTobaccoStatuses.html'),

			scope: {
				employee: '=eprTobaccoStatuses',
				editMode: '=?',
				groupNumber: '=?',
                tobaccoQuestionRequired : '=?'
			},

			controller: ['$scope', '$state', 'employee', 'sessionData', function($scope, $state, employee, sessionData) {
				var employeeMetadata = employee.metadata;

                var theUbk = sessionData.employerInfo.brandName;
                $scope.IsIBC = ((theUbk == '6009') || (theUbk == 6008))? true : false;

				$scope.hasTobaccoStatus = function(participant, groupNumber) {

                    if (
                        $state.current.name &&
                        ($state.current.name.indexOf('employee.add.coverage') >= 0 || $state.current.name === 'employee.find.addCoverage')
                    ) {
                    	return true; } else {
                    for (var i = 0, memberCoverages = participant.memberCoverages || []; i < memberCoverages.length; ++i) {
                        if (groupNumber && memberCoverages[i].groupNumber !== groupNumber) {
                            continue;
                        }
                        for (var x = 0, memberLobs = memberCoverages[i].memberLobs || []; x < memberLobs.length; ++x) {
                            if (memberLobs[x].coverageType && memberLobs[x].coverageType.toLowerCase() === 'medical') {
                                if (
                                    $state.current.name &&
                                    $state.current.name.indexOf('employee.find.review') >= 0 && $scope.editMode && $scope.tobaccoQuestionRequired
                                ){
                                    return true;
                                }
                                else {
                                    return Boolean(memberCoverages[i].tobaccoStatus);
								}

                            }
                        }
                    }
                }
				};

				$scope.hasAtLeastOneTobaccoStatus = function(groupNumber) {
					return [$scope.employee.data.subscriber].concat($scope.employee.data.dependents).some(
						function(p) { return $scope.hasTobaccoStatus(p, groupNumber); }
					);
				};

				var meetsAgeRequirement = function(birthDate, minimumTobaccoAge) {
					var millisecondsPerYear = 365 * 24 * 60 * 60 * 1000;
					var tobaccoAge = Number(minimumTobaccoAge) || Infinity;
					return (Date.now() - Date.parse(birthDate)) >= (tobaccoAge * millisecondsPerYear);
				};


				$scope.$on('editFlowDependentMedicalCoverageChange', function(evt, additionalGroupInformation, optIn) {
					console.debug('heard editFlowDependentMedicalCoverageChange');
					$scope.tobaccoQuestionRequired = additionalGroupInformation.tobaccoQuestionRequired;
                    $scope.editFlowDependentShouldShow = function(index) {
                        if (
                            $state.current.name &&
                            $state.current.name.indexOf('employee.find.review') >= 0 && $scope.editMode && $scope.tobaccoQuestionRequired
                        ){

                            if ($scope.employee.data.dependents && $scope.employee.data.dependents[index] && $scope.employee.data.dependents[index].optingIn) {
                            	return true;
                            }
                            else{
                            	return false;
							}
                        }
                        else {
                            return false;
                        }

                        //return meetsAgeRequirement(d.birthDate, additionalGroupInformation.tobaccoAge);
                    };


				});
				$scope.hasSubscriber = function (participant, groupNumber) {

                    if (
                        $state.current.name &&
                        ($state.current.name.indexOf('employee.add') >= 0 || $state.current.name === 'employee.find.addCoverage')
                    ){
					return (employeeMetadata.planCoverageOptIn && employeeMetadata.planCoverageOptIn.subscriber && employeeMetadata.planCoverageOptIn.subscriber.medical);}
					else {
                            for (var i = 0, memberCoverages = participant.memberCoverages || []; i < memberCoverages.length; ++i) {
                                if (groupNumber && memberCoverages[i].groupNumber !== groupNumber) {
                                    continue;
                                }
                                for (var x = 0, memberLobs = memberCoverages[i].memberLobs || []; x < memberLobs.length; ++x) {
                                    if (memberLobs[x].coverageType && memberLobs[x].coverageType.toLowerCase() === 'medical') {
                                        return Boolean(memberCoverages[i].tobaccoStatus);
                                    }
                                }
                            }
					}
                }
                $scope.dependentShouldShow = function(dep, index) {
                    if (
                        $state.current.name &&
                        ($state.current.name.indexOf('employee.add.coverage') >= 0 || $state.current.name === 'employee.find.addCoverage')
                    ){
                        if ($scope.employee.data.dependents && $scope.employee.data.dependents[index]) {

                            return (
                                employeeMetadata.planCoverageOptIn &&
                                employeeMetadata.planCoverageOptIn.dependents[index] &&
                                employeeMetadata.planCoverageOptIn.dependents[index].medical

                            );
                        }
					}
					else {
                        	return true;
					}

                };

				$scope.$on('medicalPlanUpdated', function(event, additionalGroupInformation, plan, planCoverageOptIn, groupNumber, productEffectiveDate) {
					$scope.planCoverageOptIn = planCoverageOptIn;
					$scope.tobaccoQuestionRequired = additionalGroupInformation.tobaccoQuestionRequired;
                    $scope.groupNumber = groupNumber;
					if ($scope.editMode && $scope.tobaccoQuestionRequired) {
						$scope.dependentShouldShow = function(dep, index) {
							if ($scope.employee.data.dependents && $scope.employee.data.dependents[index]) {
                                if( $state.current.name && $state.current.name === 'employee.find.addCoverage' &&
                                    employeeMetadata.planCoverageOptIn &&
                                    employeeMetadata.planCoverageOptIn.dependents[index] &&
                                    employeeMetadata.planCoverageOptIn.dependents[index].medical)
                                {
                                    $scope.employee.data.dependents[index]['optingIn'] = true;
                                }
								return (
									employeeMetadata.planCoverageOptIn &&
									employeeMetadata.planCoverageOptIn.dependents[index] &&
									employeeMetadata.planCoverageOptIn.dependents[index].medical
								);
							}
						};
					}
				});
			}]
		};
	});
};
